export default "__VITE_ASSET__30992a27__"